import React, { useState } from 'react';
import { Box, Button, Fade, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import YeloLogo from 'app/components/Icons/YeloLogo';
import LanguageSwitcher from 'app/components/LanguageSwitcher';
import {
  line,
  header,
  logoSide,
  notif,
  notifText,
  infoSide,
  notifBox,
  userProfileBox,
  userName,
  menuItems,
  signBox,
  signText,
  drawerHeader,
  headerBox,
  permissionBox,
  headerBtnsBox,
} from './Header.sx';
import EditIcon from 'app/components/Icons/EditIcon';
import MailIcon from 'app/components/Icons/MailIcon';
import UserIcon from 'app/components/Icons/UserIcon';
import DownArrowIcon from 'app/components/Icons/DownArrowIcon';
import ProfileIcon from 'app/components/Icons/ProfileIcon';
import LogoutIcon from 'app/components/Icons/LogoutIcon';
import SignPermissionIcon from 'app/components/Icons/SignPermissionIcon';
import useHeader from 'app/components/Header/useHeader';
import { black1, grey10 } from 'app/components/ThemeProvider/colors';
import DrawerCustom from '../DrawerCustom';
import BurgerMenuIcon from '../Icons/BurgerMenuIcon';
import { MenuData } from 'app/constants/types';
import CloseIcon from '../Icons/CloseIcon';
import ClockIcon from 'app/components/Icons/ClockIcon';
import { NavLink } from 'react-router-dom';

interface Props {
  sign: string;
  title: string;
  mailbox: number;
  menu?: MenuData[];
}

const Header = (props: Props) => {
  const [openBurger, setOpenBurger] = useState(false);

  const { sign, title, mailbox, menu } = props;
  const {
    t,
    open,
    anchorEl,
    handleClick,
    handleClose,
    handleRedirectTransfer,
    handleRedirectLastOperations,
    mediumScreen,
    largeScreen,
    handleLogout,
    handleUserProfile,
  } = useHeader();

  if (sign === undefined && title === undefined && mailbox === undefined) {
    return <Box sx={{ height: '110px', width: '100vw', background: grey10 }}></Box>;
  }

  return (
    <Box>
      <Box sx={line}></Box>
      <Box sx={header}>
        <Box sx={logoSide}>
          <NavLink to={`/az/home-page`}>
            <YeloLogo sx={{ width: '80px', height: '40px' }} />
          </NavLink>
          {/*<LanguageSwitcher homePage={true} />*/}
        </Box>
        <Box sx={infoSide}>
          <DrawerCustom menu={menu} setOpen={setOpenBurger} open={openBurger} hide={mediumScreen}>
            {mediumScreen && <Box sx={line}></Box>}
            <Box sx={drawerHeader}>
              <Box sx={headerBtnsBox}>
                <Button size={mediumScreen ? 'medium' : 'large'} onClick={handleRedirectTransfer}>
                  <EditIcon sx={{ fill: 'transparent' }} />
                  {t('homePage.createTransfer')}
                </Button>
                <Button
                  size={mediumScreen ? 'medium' : 'large'}
                  color={'secondary'}
                  onClick={handleRedirectLastOperations}
                >
                  <ClockIcon sx={{ fill: 'transparent' }} />
                  {t('homePage.history')}
                </Button>
              </Box>
              <Box sx={headerBox}>
                <Box sx={signBox(false)}>
                  <Tooltip
                    title={
                      sign === 'first'
                        ? t('homePage.firstSignature')
                        : sign === 'second'
                        ? t('homePage.secondSignature')
                        : 'İmza hüququ yoxdur'
                    }
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: '#ffffff',
                          textAlign: 'center',
                          color: black1,
                          border: '0.5px solid rgba(0, 0, 0, 0.1)',
                          fontFamily: 'Yelo',

                          display: mediumScreen || largeScreen ? 'none' : 'block',

                          '& .MuiTooltip-arrow': {
                            color: '#ffffff',
                          },
                        },
                      },
                      arrow: {
                        sx: {
                          '&:before': {
                            border: '0.5px solid rgba(0, 0, 0, 0.1)',
                          },
                        },
                      },
                    }}
                  >
                    <Box sx={permissionBox}>
                      <SignPermissionIcon />
                      <Typography sx={signText}>
                        {sign === 'first'
                          ? t('homePage.firstSignature')
                          : sign === 'second'
                          ? t('homePage.secondSignature')
                          : 'İmza hüququ yoxdur'}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {/*<Box sx={notifBox}>*/}
                    {/*  <MailIcon sx={{ fill: 'transparent' }} />*/}
                    {/*  {mailbox > 0 && (*/}
                    {/*    <Box sx={notif}>*/}
                    {/*      <Typography sx={notifText}>{mailbox}</Typography>*/}
                    {/*    </Box>*/}
                    {/*  )}*/}
                    {/*</Box>*/}
                    <Button
                      sx={userProfileBox}
                      variant={'text'}
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      <UserIcon sx={{ fill: 'transparent' }} />

                      <Tooltip
                        title={title}
                        TransitionComponent={Fade}
                        TransitionProps={{ timeout: 600 }}
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: '#ffffff',
                              textAlign: 'center',
                              color: black1,
                              border: '0.5px solid rgba(0, 0, 0, 0.1)',
                              fontFamily: 'Yelo',

                              '& .MuiTooltip-arrow': {
                                color: '#ffffff',
                              },
                            },
                          },
                          arrow: {
                            sx: {
                              '&:before': {
                                border: '0.5px solid rgba(0, 0, 0, 0.1)',
                              },
                            },
                          },
                        }}
                      >
                        <Typography sx={userName}>{title}</Typography>
                      </Tooltip>
                      <DownArrowIcon
                        sx={{
                          fill: 'transparent',
                          width: '16px !important',
                          height: '16px !important',
                          transform: open && 'rotate(180deg)',
                        }}
                      />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                      sx={{ boxShadow: 'none' }}
                    >
                      <MenuItem onClick={handleUserProfile} sx={menuItems}>
                        <ProfileIcon />
                        Müştəri profili
                      </MenuItem>
                      <MenuItem onClick={handleLogout} sx={menuItems}>
                        <LogoutIcon />
                        Çıxış
                      </MenuItem>
                    </Menu>
                  </Box>
                  {mediumScreen && (
                    <Button
                      sx={{
                        backgroundColor: 'transparent',
                        width: '40px',
                        height: '40px',
                        p: '8px !important',
                        minWidth: '0px',
                      }}
                      size={'medium'}
                      variant={'outlined'}
                      onClick={() => setOpenBurger(false)}
                    >
                      <CloseIcon />
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </DrawerCustom>
          {mediumScreen && (
            <Button
              sx={{
                backgroundColor: 'transparent',
                width: '40px',
                height: '40px',
                p: '8px !important',
                minWidth: '0px',
              }}
              size={'medium'}
              variant={'outlined'}
              onClick={() => setOpenBurger(true)}
            >
              <BurgerMenuIcon />
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
